import authentication from '@/modules/apies/authentication'
import user from '@/modules/apies/user/user'
import userrole from '@/modules/apies/user/userrole'
import userpermission from '@/modules/apies/user/userpermission'
import usertoken from '@/modules/apies/user/usertoken'
import circular from '@/modules/apies/circular/circular'
import blog from '@/modules/apies/blog/blog'
import blogcategory from '@/modules/apies/blog/blogcategory'
import blogcomment from '@/modules/apies/blog/blogcomment'
import country from '@/modules/apies/public/country'
import state from '@/modules/apies/public/state'
import city from '@/modules/apies/public/city'
import brand from '@/modules/apies/product/brand'
import producttariff from '@/modules/apies/product/producttariff'
import product from '@/modules/apies/product/product'
import productunit from '@/modules/apies/product/productunit'
import purchasetype from '@/modules/apies/product/purchasetype'
import ticketcategory from '@/modules/apies/ticket/ticketcategory'
import ticket from '@/modules/apies/ticket/ticket'
import customs from '@/modules/apies/customs/customs'
import customsprocedure from '@/modules/apies/customs/customsprocedure'
import customstype from '@/modules/apies/customs/customstype'
import customsgood from '@/modules/apies/customs/customsgood'
import tircarnet from '@/modules/apies/customs/tircarnet'
import consultingcategory from '@/modules/apies/consulting/consultingcategory'
import consultingprofile from '@/modules/apies/consulting/consultingprofile'
import consultingbooking from '@/modules/apies/consulting/consultingbooking'
import consultingreview from '@/modules/apies/consulting/consultingreview'
import bank from '@/modules/apies/wallet/bank'
import withdrawal from '@/modules/apies/wallet/withdrawal'
import wallet from '@/modules/apies/wallet/wallet'
import payment from '@/modules/apies/payment'
import advertisement from '@/modules/apies/advertisement/advertisement'
import circularprocesstype from '@/modules/apies/circular/circularprocesstype'
import circulardocumenttype from '@/modules/apies/circular/circulardocumenttype'
import productcategory from '@/modules/apies/product/productcategory'
import agent from '@/modules/apies/agent/agent'
import merchant from '@/modules/apies/merchant/merchant'
import currency from '@/modules/apies/currency/currency'

export default {
  authentication,
  user,
  userrole,
  userpermission,
  usertoken,
  circular,
  blog,
  blogcategory,
  blogcomment,
  country,
  state,
  city,
  brand,
  producttariff,
  product,
  productunit,
  purchasetype,
  ticketcategory,
  ticket,
  customs,
  customsprocedure,
  customstype,
  customsgood,
  tircarnet,
  consultingcategory,
  consultingprofile,
  consultingbooking,
  consultingreview,
  bank,
  withdrawal,
  wallet,
  payment,
  advertisement,
  circularprocesstype,
  circulardocumenttype,
  productcategory,
  agent,
  merchant,
  currency,
}
